import React, { useEffect, useState } from "react";
import "./Home.scss";
import SubHeader from "../../components/SubHeader";
import Header from "../../components/Header";
import { motion } from 'framer-motion';

import SaldoBox from "../../components/Home/Saldo Box/SaldoBox";
import BoxPages from "../../components/Home/BoxPages/BoxPages";
import BoxAggiornamento from "../../components/Home/BoxAggiornamento/BoxAggiornamento";
import { useDispatch, useSelector } from "react-redux";
import Ricaricabile from "../../components/Home/InfoBox/Ricaricabile";
import Relax from "../../components/Home/InfoBox/Relax";
import Tradizionale from "../../components/Home/InfoBox/Tradizionale";
import NewHeader from "../../components/New Header/NewHeader";
import Saldo from "../../components/Saldo/_saldo";
import Box3612 from "../../components/Home/Box3612/Box3612";
import AlertNotice from "../../components/AlertNotice/AlertNotice";
import useWindowFocus from "use-window-focus";
import Box3612Home from "../../components/Home/Box3612/Box3612Home";
import axios from "axios";
import { setPayMethodDefault, setSoglia, setTaglia } from "../../features/userSlice";
import md5 from "md5";
import CheckMethodPayment from "../../components/ChekMethodPayment/CheckMethodPayment";
import sanityClient from '../../client.js'
import Card from "../../components/Home/Cards/Card";
import StoriesComponent from "../../components/Home/Stories/Stories";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import {arrayMoveImmutable} from "array-move";

function HomeNew() {
  const dispatch = useDispatch()
  const idGroup = useSelector((user) => user.user.idGruppo);
  const prenotazioneEffettuata = useSelector(
    (user) => user.settings.ricarica3612Effettuata
  );
  const statusNotice = useSelector((user) => user.settings.overlayNotice);
  const windowFocused = useWindowFocus();
  const customerId = useSelector((user) => user.user.info.customer_id);
  const tkn = md5(customerId + "oYmAIdtki%lu");
  const [cards, setCards] = useState()

  useEffect(() => {
    window.scrollTo(0, 0)
    // document.body.style.overflow ="hidden";
    // document.body.style.touchAction = "none";
    init()
    getCards()
  }, [windowFocused])
  const init = async () => {
    const url = `https://my.revoluce.it/area_utente/gestione/api/customers/getSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}`;
    const { data } = await axios.get(url);
    const result = data.data[0];
    dispatch(setTaglia(result.importo_taglia));
    dispatch(setSoglia(result.soglia_incasso));
    const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}`;
    const rest = await axios.get(apiMethod);
    dispatch(setPayMethodDefault(rest.data.dati.metodo_predefinito));
  };

  const getCards = async () => {
    sanityClient
      .fetch(
        `*[_type == 'cards']{
          _id,
          ...
        }`
      )
      .then((data) => setCards(data))
      .catch(console.error);
  }
  const [box, setBox] = useState([idGroup === 1 ? <Ricaricabile /> : idGroup === 2 ? <Relax/> : <Tradizionale />, prenotazioneEffettuata ? <Box3612Home /> : <Box3612 />, <CheckMethodPayment />])
  const SortableItem = sortableElement(({ value }) => <li style={{margin: '20px 0', listStyle: 'none'}}>{value}</li>);

  const SortableContainer = sortableContainer(({ children }) => {
    return <ul style={{padding: '0'}}>{children}</ul>;
  });
  const onSortEnd = ({oldIndex, newIndex}) => {
    // setBox(({items}) => ({
    //   items: arrayMoveImmutable(items, oldIndex, newIndex),
    // }));
    setBox(arrayMoveImmutable(box, oldIndex, newIndex))
  };
  return (
    <div className="homeNew" id="homeNew">
      {statusNotice ? (
        <AlertNotice
          title="Aggiornamento contrattuale"
          paragraphOne="Caro Revoluzionario, l’aumento delle tariffe energetiche ha
          colpito anche noi e in attesa dei promessi interventi
          governativi che dovrebbero alleviare la situazione del mercato
          elettrico siamo costretti ad adeguarci."
          paragraphTwo="Con decorrenza 1° marzo 2022, come previsto dall’art. 6 del
          contratto di fornitura, verranno applicati i nuovi costi di
          approvvigionamento della materia energia affrontati da Revoluce
          per continuare a fornirti."
        />
      ) : null}
      <div className="homeNew-top">
        {/* header  */}
        <NewHeader logo="white" padding="no" iconsColor="white" />
      </div>
      <div className="homeNew-bottom">
        <StoriesComponent />
        <SubHeader />
        <Saldo />
        <SaldoBox />
        {/* <SortableContainer onSortEnd={onSortEnd}>
          {box.map((value, index) => (
            <SortableItem key={`item-${value}`} index={index} value={value} />
          ))}
        </SortableContainer> */}
        {idGroup === 1 ? (
          <Ricaricabile />
        ) : idGroup === 2 ? (
          <Relax />
        ) : (
          <Tradizionale />
        )}
        {/* <BoxAggiornamento /> */}
        {prenotazioneEffettuata ? <Box3612Home /> : (
          <Box3612 />
        )}
        <CheckMethodPayment />
        {
          cards && cards.map((r, i) => (
            <Card  key={i} data={r} />
          ))
        }
        
        <div className="emptyBox" style={{ height: '100px' }}></div>
      </div>
    </div>
  );
}

export default HomeNew;
